export default {
  location: 'Local',
  person: 'Pessoa',
  fleet: 'Frota',
  assets: 'Ativos',
  deactivatedPlace: 'Este QR Code está atrelado a um local desativado.'
}
